import React, { useEffect, useRef } from "react";
import "./Quienessomos.css";
import { cards } from "./QuienessomosCards.js";
import belen from "../../assets/img/Quienessomos/belen.webp";
import dai from "../../assets/img/Quienessomos/dai.webp";
import video from "../../assets/img/Quienessomos/video.mp4";

export const Quienessomos = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Función para reproducir el video en bucle al cargar la página
    const playVideo = () => {
      videoRef.current.play();
    };

    // Función para reiniciar el video cuando se completa
    const restartVideo = () => {
      videoRef.current.currentTime = 0;
    };

    // Agregar event listeners
    const videoElement = videoRef.current;
    videoElement.addEventListener("canplaythrough", playVideo);
    videoElement.addEventListener("ended", restartVideo);

    // Limpiar event listeners cuando el componente se desmonta
    return () => {
      videoElement.removeEventListener("canplaythrough", playVideo);
      videoElement.removeEventListener("ended", restartVideo);
    };
  }, []);

  return (
    <section id="quienessomos">
      <h3 className="quienessomos-title">Identidad Mendocina</h3>
      <div className="quienessomos-presentation">
        <div className="quienessomos-presentation-container quienessomos-presentation-container-left">
          <img
            src={belen}
            alt="imagen de Belén"
            className="quienessomos-presentation--image"
          />
          <div className="quienessomos-presentation--fondo"></div>
        </div>
        <div className="quienessomos-presentation--text">
          <p>
            <span>Somos Bel y Dai</span>, diseñadoras de indumentaria y
            emprendedoras.
          </p>
          <p>
            En noviembre de 2020 pusimos en marcha <span>VERDIVIA</span>,
            proyecto en el que creamos propuestas de diseño textil con identidad
            propia e inspiradas en Mendoza. Producimos indumentaria y accesorios
            con un proceso amigable con el ambiente y las personas.
          </p>
          <p>
            El nombre elegido -VERDIVIA- nace del juego de nuestros apellidos
            VERASAY/VALDIVIA y remite a Vendimia: celebración que pone en escena
            la cultura mendocina, el trabajo del cultivo y cosecha de la vid.
          </p>
        </div>
        <div className="quienessomos-presentation-container quienessomos-presentation-container-right">
          <img
            src={dai}
            alt="imagen de Dai"
            className="quienessomos-presentation--image"
          />
          <div className="quienessomos-presentation--fondo"></div>
        </div>
      </div>
      <div className="quienessomos-cards">
        {cards.map((card) => (
          <div key={card.id} className="quienessomos-cards--card">
            <picture>
              <card.icon className="card-icon" />
            </picture>
            <h5>{card.title}</h5>
            <p>{card.text}</p>
          </div>
        ))}
      </div>
      <div className="quienessomos-proceso">
        <h4>Proceso de diseño</h4>
        <video ref={videoRef} autoPlay loop muted className="video">
          <source src={video} type="video/mp4" />
        </video>
        <div className="quienessomos-proceso--text">
          <span>Nuestro proceso de diseño está atravesado por lo lúdico.</span>
          <p>
            Encontramos la inspiración en Mendoza: su arquitectura, sus
            productos, su naturaleza. Seleccionamos los elementos que más nos
            atraen de esa inspiración y con ellos creamos los estampados que se
            aplican al textil con el que confeccionamos nuestras prendas y
            accesorios.
          </p>
        </div>
      </div>
    </section>
  );
};
